<template>
    <b-card class="mb-5">
        <b-row class="mb-2">
            <b-col md="10">
                <h3>{{$route.name}}</h3>
                <b-breadcrumb>
                    <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="2 mt-4">
                <b-button variant="primary" class="float-right btn-custom" :to="'purchase/create'"><font-awesome-icon icon="plus" /></b-button>
            </b-col>
        </b-row>
        <div class="border-bottom mb-2"></div>
        <b-row class="mt-3 mb-2">
            <!-- <b-col md="4 mb-2">
                <b-form-input  placeholder="Supplier ID"/>
            </b-col>
            <b-col md="4 mb-2">
                <b-form-input placeholder="Supplier Name"/>
            </b-col> -->
        </b-row>
        <paginated-table ref="dataTable" :can-view="true" :can-delete="false" :can-edit="true" :data-url="apiUrl.purchase" :can-reject="true" :data-key="dataKey" :data-columns="columns" :data-params="['supplier_uuid', 'type', 'name', 'purchase_id']">
        </paginated-table>
    </b-card>
</template>
<script>
import PaginatedTable from '../../../components/PaginatedTable.vue'
export default {
  components: { PaginatedTable },
    data(){
        return {
            dataKey: 'purchase',
            apiUrl:{
                purchase: window.AppConfig.apiUrl + 'purchase'
            },
            columns: [
                {
                    key: 'purchaseId',
                    label: 'Purchase Id'
                },
                {
                    key: 'purchaseDate',
                    label: 'Date'
                },
                // {
                //     key: 'purchaseItem',
                //     label: 'Item',
                //     class: 'w-25'

                // },
                {
                    key: 'purchaseTotalPayment',
                    label: 'Purchase Payment',
                    class: 'w-10'
                },
                {
                    key: 'purchaseUnpaidBill',
                    label: 'Unpaid Bill',
                    class: 'w-10'
                },
                {
                    key: 'purchaseTotal',
                    label: 'Purchase Total',
                    class: 'w-10'
                },
                {
                    key: 'purchaseStatus',
                    label: 'Status',
                    class: 'text-center'
                },
                {
                    key: 'actionPurchase',
                    label: ''
                }
            ]
        }
    }
}
</script>